module.exports = __webpack_public_path__ + "static/lamb-c01639da5f5eaaf7924374f3506b6063.png";